// @flow

import { BlogCategory } from '@screens';

export default BlogCategory;
